/**
 * These correspond to TaskType#name that we know exist in all backend regions.
 */
export enum TaskTypeNames {
  CUSTOM_TASK = "custom",
}
